import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";

import {BaseToastNotification} from "../base-toast-notification.tsx";

export const ChangesSavedNotification = (props: {
    message?: string;
}): React.ReactElement => {
    return (
        <BaseToastNotification
            style={styles.toast}
            closeIconColor={semanticColor.core.foreground.knockout.default}
        >
            {props.message || t`Your changes have been saved.`}
        </BaseToastNotification>
    );
};

const styles = StyleSheet.create({
    toast: {
        backgroundColor: semanticColor.core.background.instructive.default,
        color: semanticColor.core.foreground.knockout.default,
        width: "auto",
        marginInlineStart: spacing.medium_16,
        marginInlineEnd: spacing.medium_16,
    },
});
